<!--
 * @Description: 内部单位合同
 * @Author: luzx
 * @Date: 2023-05-15 11:51:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-15 11:51:00
-->
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main>
                <div class="header_right" @click="showCardNav = !showCardNav">
                    <div class="title">搜索</div>
                    <div>
                        <transition name="from"></transition>
                        <span v-show="!showCardNav">
                            <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
                        </span>
                        <transition name="to"></transition>
                        <span v-show="showCardNav">
                            <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
                        </span>
                    </div>
                </div>
                <div v-show="showCardNav" class="hr"></div>
                <el-collapse-transition>
                    <div v-show="showCardNav">
                        <div class="search">
                            <span style="display: inline-block;margin-bottom: 10px;">
                                <span style="margin-right: 12px">甲方单位</span>
                                <el-input v-model="tableParam.firstParty" style="width: 240px" clearable placeholder="请输入"
                                    @keyup.enter.native="gettableData()" />
                            </span>
                            <span style="margin-left: 24px">
                                <span style="margin-right: 12px">乙方单位</span>
                                <el-input v-model="tableParam.secondParty" style="width: 240px" clearable placeholder="请输入"
                                    @keyup.enter.native="gettableData()" />
                            </span>
                            <span style="margin-left: 24px">
                                <span style="margin-right: 12px">合同类型</span>
                                <el-select v-model="tableParam.contractTypeId" placeholder="请选择" style="width: 240px" clearable>
                                    <el-option v-for="(item, index) in settlementTypelist" :key="index" :label="item.value"
                                        :value="item.id"></el-option>
                                </el-select>
                            </span>
                            <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="gettableData()">查
                                询</el-button>
                        </div>
                    </div>
                </el-collapse-transition>
                <div class="hr"></div>
                <div class="card">
                    <internalunit v-if="currenindex == 6" ref="internalunit" @sumbit="init"></internalunit>
                </div>
            </el-main>
        </el-container>
        <el-dialog v-dialogDrag :visible.sync="searchDialog" width="580px" :close-on-click-modal="false"
            :before-close="search">
            <span slot="title" class="dialog-title">高级搜索</span>
            <div class="dialoginfo">
                <el-form ref="reftableParam" :inline="true" :model="tableParam" label-width="110px">
                    <el-form-item>
                        <span slot="label">供应商类别</span>
                        <el-input v-model="tableParam.supplierType" tplaceholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <span slot="label">合作等级</span>
                        <el-select v-model="tableParam.cooperationClassId" placeholder="请选择">
                            <el-option v-for="item in cooperationIdlist" :key="item.id" :label="item.itemName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <span slot="label">招标编号</span>
                        <el-input v-model="tableParam.callForBidsNumber" tplaceholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <span slot="label">状态</span>
                        <el-select v-model="tableParam.enable" placeholder="请选择">
                            <el-option :key="2" label="禁用" :value="0"></el-option>
                            <el-option :key="1" label="启用" :value="1"></el-option>
                            <el-option :key="3" label="全部" value=""></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
            <span slot="label">合同Id</span>
            <el-input :key="tableParam.code" v-model="tableParam.code" tplaceholder="请输入"
              clearable></el-input>
          </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two"
                    @click="searchDialog = false, tableParam.supplierType = '', tableParam.cooperationClassId = '', tableParam.callForBidsNumber = ''">取
                    消</el-button>
                <el-button class="bottom_all" style="margin-left: 24px" @click="gettableData(), searchDialog = false">搜
                    索</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import breaDcrumb from "@/components/breadcrumb";
import internalunit from "../components/internalunit.vue"; //外协
// import { getDicsType } from "@/api/common.js";
export default {
    mixins: [mixin],
    components: {
        internalunit,
        breaDcrumb,
    },
    data() {
        return {
            currenindex: 6,
            contractTypelist: [
                { value: "原物料", id: 1 },
                { value: "车辆外包", id: 2 },
                { value: "设备外包", id: 3 },
                { value: "泵管外包", id: 4 },
                { value: "外协合同", id: 5 },
                { value: "协外合同", id: 6 },
            ],
            settlementTypelist: [
                { value: "购销", id: 1 },
                { value: "代加工", id: 2 },
            ],
            searchDialog: false,
            supplierTypelist: [],
            cooperationIdlist: [],
            pagesType: 0,
            tableParam: {
                page: 1,
                pageSize: 10,
            },
            showCardNav: true,
        };
    },
    created() {
        this.tableParam = { ...this.tableParam, contractTypeId: '', firstParty: "", secondParty: "",code:"" };
    },
    mounted() {
        this.gettableData();
    },
    methods: {
        init() {
            setTimeout(() => {
                this.tableParam = { ...this.tableParam, contractTypeId: '', firstParty: "", secondParty: "",code:"" };
                this.$refs.internalunit.initt(this.tableParam);
            }, 100);
        },
        gettableData() {
            setTimeout(() => {
                this.tableParam.page = 1;
                this.$refs.internalunit.srarch(this.tableParam);
            }, 100);
        },
        choose(num) {
            this.currenindex = num;
            this.gettableData();
        },
        search() {
            this.searchDialog = false;
            this.gettableData();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 320px;
}

.dialoginfo {
    padding: 0 20px 0 20px;
}

.dialoginfo-title {
    display: flex;
    align-items: center;
    height: 50px;

    >div {
        width: 4px;
        height: 20px;
        background: $bg_color;
    }

    >span {
        padding-left: 10px;
        font-size: 20px;
        color: $bg_color;
        font-weight: bold;
    }
}

.tabtop {
    width: 948px;
    display: flex;
    border: $bg_color 1px solid;
    border-radius: 4px;
    margin: 20px 20px 0 20px;

    >div {
        height: 40px;
        width: 190px;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
        display: flex;
        align-items: center;

        .text {
            width: 188px;
            @include discen;
            line-height: 40px;
            color: $bg_color;
        }

        .active {
            width: 188px;
            @include discen;
            line-height: 40px;
            color: #ffffff;
            background: $bg_color;
            border-radius: 4px;
        }

        .hr {
            height: 20px;
            width: 2px;
            background: $bg_color;
        }
    }
}
</style>
  